// extracted by mini-css-extract-plugin
export default {"item":"Item_item__KFUxI","itemSelecionado":"Item_itemSelecionado__8y8fi","itemCompletado":"Item_itemCompletado__UX46Q","concluido":"Item_concluido__Un-Zp"};